import React from 'react'
import PropTypes from 'prop-types'

class WaterClarityTooltip extends React.Component {
  render() {
    const { active } = this.props

    if (active) {
      const { payload, label } = this.props

      if (payload && payload[0]) {
        var createdAt = payload[0].payload.createdAt
        var employee = payload[0].payload.employee

        if (payload[0].value == 2) {
          var waterClarity = 'Clear'
        }
        else {
          var waterClarity = 'Cloudy'
        }

        return (
          <div className="well shadowDepth1">
            <p>
              <span className="grey-text">
                {createdAt}
                <br />
                {employee}
              </span>
              <br />
              <span className="small-text">
                <span style={{color: payload[0].color}}>
                  Water Clarity: {waterClarity}
                </span>
                <br />
              </span>
            </p>
          </div>
        );
      }
      else {
        return null;
      }
    }

    return null;
  }
}

WaterClarityTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.string
}

export default WaterClarityTooltip
